import { render, staticRenderFns } from "./AllStatementsPage.vue?vue&type=template&id=58cedc2e&scoped=true&"
import script from "./AllStatementsPage.vue?vue&type=script&lang=js&"
export * from "./AllStatementsPage.vue?vue&type=script&lang=js&"
import style0 from "./AllStatementsPage.vue?vue&type=style&index=0&id=58cedc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cedc2e",
  null
  
)

component.options.__file = "AllStatementsPage.vue"
export default component.exports